import Guard from "../../../Utils/Guard";
import Cancellation from "../../organisms/account/Cancellation";
import AuthenticatedTemplate from "../../templates/AuthenticatedTemplate";

function CancellationPage() {
  return <AuthenticatedTemplate main={<Cancellation />} />;
}

export default Guard(CancellationPage);
